import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Institution, InstitutionProposal } from 'cb-model';
import {
  Display,
  NavIconContainer,
  PageTitle,
  PaginatorAndListSettings,
  QuerySingle,
  Search,
  Section,
  useCacheQuery,
  useCacheRecord,
} from 'gossamer-front-end';
import { getFilter, QueryOptions } from 'gossamer-unified';
import { Button } from 'react-bootstrap';

export const InstitutionProposalDisplay = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const record = useCacheRecord(InstitutionProposal, params.key);

  const onRowClick = (instValue: string) => {
    navigate(`../action/${params.key}?existingInstitution=${instValue}`);
  };

  const onButtonClick = () => {
    navigate(`../action/${params.key}`);
  };

  return (
    <>
      <NavIconContainer entityId={InstitutionProposal.id} />
      <PageTitle
        verb="Display"
        entity={InstitutionProposal}
        keyValue={params.key}
        subtitle="Details relating to an Institution Proposal"
      />
      <Section>
        <QuerySingle entity={InstitutionProposal} keyValue={params.key} render={Display} />
      </Section>

      {record.data && <InstitutionMatcher name={record.data.institution_name} onRowClick={onRowClick} />}

      <div>
        <Button variant="primary" onClick={onButtonClick}>
          No matching institution
        </Button>
      </div>
    </>
  );
};

interface InstitutionMatcherProps {
  name: string;
  onRowClick: (newValue: string) => void;
}

const InstitutionMatcher = (props: InstitutionMatcherProps) => {
  const [queryOptions, setQueryOptions] = React.useState({
    where: { and: [getFilter('name', 'ct', props.name)] },
    order: InstitutionProposal.defaultSort,
  } as QueryOptions);
  const gCacheQueryItem = useCacheQuery(Institution, queryOptions);

  return (
    <Section title="Search for Matching Institution">
      <PaginatorAndListSettings
        entity={Institution}
        gCacheQuery={gCacheQueryItem}
        onRowClick={props.onRowClick}
        queryOptions={queryOptions}
        render={Search}
        setQueryOptions={setQueryOptions}
      />
    </Section>
  );
};
